// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"264d495c","24":"ab526ce8","165":"bd1f55d9","444":"4de1f60d","715":"6e02d9d8","787":"1eef23a1"}[chunkId] + ".chunk.js";
};